import { ActionType } from '../infrastructure/actionTypes';
import { ISeedIcon } from '../infrastructure/interfaces';

export default (list: ISeedIcon[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_SEED_ICONS_DONE:
      const { seedIcons } = action;
      return seedIcons;

    case ActionType.TOGGLE_SEED_ICON_PUBLISH_DONE:
      const { toggledSeedIcon } = action;
      const toggledList = list.map((s) => {
        return (s.id == toggledSeedIcon.id) ? toggledSeedIcon : s
      });
      return toggledList

    case ActionType.EDIT_SEED_ICON_DONE:
      const { updatedSeedIcon } = action;
      const updatedList = list.map((s) => {
        return (s.id == updatedSeedIcon.id) ? updatedSeedIcon : s
      });
      return updatedList

    case ActionType.DELETE_SEED_ICON_DONE:
      const filteredIcons = list.filter(icon => icon.id !== action.iconId);
      return filteredIcons;

    case ActionType.CREATE_SEED_ICON_DONE:
      const { newSeedIcon } = action;
      return list.concat(newSeedIcon);

    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/seedIconList.ts